import React from "react";
import MDTypography from "components/MDTypography";
import { useContext } from "react";
import { UserContext } from "App";
import "./style.scss";

const PaymentButton = ({ AccSession, onClick, disabled }) => {
  const User = useContext(UserContext);

  if (!User) {
    return <div>Loading...</div>;
  }

  if (
    AccSession.packageId != null ||
    ((!["Admin", "Owner", "HeadAccounting"].includes(User.userType)) &&
      User.userType != "AccountingEmployee" &&
      User.userType != "Therapist" &&
      User.userType != "FloorManager" &&
      User.userType != "AppointmentEmployee" &&
      User.userType != "CallCenterEmployee" &&
      User.userType != "SubAdmin")
  ) {
    if (AccSession.isPaidFor) {
      return <span className="btn btn-success">Package</span>;
    } else {
      return <span className="btn btn-danger">Package</span>;
    }
  }

  let buttonText = "";
  let buttonClass = "";
  let isDisabled = disabled || false;

  if (AccSession.isPaidFor) {
    buttonText = "Refund";
    buttonClass = "btn btn-warning";
  } else {
    buttonText = "Pay";
    buttonClass = "btn btn-success";
  }
  if (AccSession.isAbsent) {
    buttonText = "Absent";
    buttonClass = "btn btn-danger";
    isDisabled = true;
  }

  return (
    <MDTypography variant="button" fontWeight="regular" color="text">
      <button disabled={isDisabled} onClick={onClick} className={buttonClass}>
        {buttonText}
      </button>
    </MDTypography>
  );
};

export default PaymentButton;
